import {
    createSlice,
} from "@reduxjs/toolkit"
import {
    setError,
    setLoadingAndError
} from "../../components/common/slice_state"
import { searchDataset, getPurchasedSets } from "../Thunks/datasetThunks"

const initialState = {
    datasets: null,
    ownedDatasets : [],
    transactionDetails: null,
    fullData : null,
    loading: false,
    error: null
}


export const dataSetSlice = createSlice({
    name: "datasets",
    initialState,
    reducers:{
        addToFullDataSet: (state, action) => {
            state.fullData = action.payload
        },
        addTransactionDetails: (state, action) =>{
            console.log(action.payload)
            state.transactionDetails = action.payload
        }

    },
    extraReducers: (builder) => {
        builder

        .addCase(searchDataset.pending, setLoadingAndError)
        .addCase(searchDataset.fulfilled, (state, action) => {
            state.datasets = action.payload || []
            state.loading = false;
        })
        .addCase(searchDataset.rejected, setError)

        .addCase(getPurchasedSets.pending, setLoadingAndError)
        .addCase(getPurchasedSets.fulfilled, (state, action) => {
            state.ownedDatasets = action.payload || null
            state.loading = false;
        })
        .addCase(getPurchasedSets.rejected, setError)
    }
})


export const datasetCard = state => state.datasetReducer.datasets
export const purchasedDatasets = state => state.datasetReducer.ownedDatasets
export const getTransactionDetails = state => state.datasetReducer.transactionDetails



export const {addToFullDataSet, addTransactionDetails} = dataSetSlice.actions


export default dataSetSlice.reducer
